import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import { getCode, getToken, getOpenId, getAccessToken } from "@/functions";

import * as mutations from "./mutations";
import * as actions from "./actions";

const store = new Vuex.Store({
  state: {
    code: getCode(), // 公众号 code
    token: getToken(), // 自己服务的验证信息
    openId: getOpenId(), // 微信用户唯一标示
    accessToken: getAccessToken(), // 微信服务的验证信息
    userFromWX: {}, // 微信的用户信息
    userFromJava: {}, // 自己服务的用户信息
    shopCar: [],
    homeBanners: [],
    homeHeadingNews: [],
    homeGoods: [],
    homeMarkets: [],
    analysis: {
      totalCustomers: 0,
      increaseCustomer: 0,
      exploreViewCount: 0,
      homeViewCount: 0
    }
  },
  getters: {
    token: (state) => state.token,
    hasLogin: ({ token }) => !!token,
  },
  mutations,
  actions,
});

export default store;
